import { Dispatch, SetStateAction } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Rating, } from '@mui/material'
import React from 'react';

interface RatingModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
}

export default function RatingModal({ open, onClose, setOpen }: RatingModalProps) {

    const [value, setValue] = React.useState<number | null>(4);

    return (
        <Modal
            className="modal rating_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Rating Detail</h2>
                        <div className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </div>
                    </div>
                    <div className="view_page gap_p">
                        <div className="w_100">
                            <h6>Rating</h6>
                            <Rating name="read-only" value={value} readOnly />
                        </div>
                        <div className="w_100">
                            <h6>Review</h6>
                            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad a harum, autem placeat veniam alias fugiat? Fugiat itaque iste veniam nemo, provident est soluta ipsa reprehenderit esse eligendi, maxime quo dolorum obcaecati quidem labore maiores, dignissimos incidunt tempore deleniti eius. Accusamus molestiae porro distinctio quae unde laudantium a magnam impedit.</p>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}
